import { Plus, Trash2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { ICustomField } from "@/features/servers/schemas/servers";

interface CustomFieldsEditorProps {
  fields: ICustomField[];
  onChange: (fields: ICustomField[]) => void;
  disabled?: boolean;
}

/**
 * Editor libre clave/valor sin esquema fijo.
 */
export function CustomFieldsEditor({
  fields,
  onChange,
  disabled = false,
}: CustomFieldsEditorProps) {
  const update = (index: number, patch: Partial<ICustomField>) => {
    onChange(fields.map((f, i) => (i === index ? { ...f, ...patch } : f)));
  };

  const remove = (index: number) => {
    onChange(fields.filter((_, i) => i !== index));
  };

  const add = () => {
    onChange([...fields, { key: "", value: "" }]);
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label>Campos personalizados</Label>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={add}
          disabled={disabled}
        >
          <Plus className="h-3.5 w-3.5 mr-1" />
          Agregar
        </Button>
      </div>
      {fields.length === 0 ? (
        <p className="text-xs text-muted-foreground">Sin campos custom.</p>
      ) : (
        <div className="space-y-2">
          {fields.map((field, index) => (
            <div key={index} className="flex gap-2 items-start">
              <Input
                placeholder="Clave"
                value={field.key}
                onChange={(e) => update(index, { key: e.target.value })}
                disabled={disabled}
                className="flex-1"
              />
              <Input
                placeholder="Valor"
                value={field.value}
                onChange={(e) => update(index, { value: e.target.value })}
                disabled={disabled}
                className="flex-1"
              />
              <Button
                type="button"
                variant="ghost"
                size="icon"
                onClick={() => remove(index)}
                disabled={disabled}
                aria-label="Eliminar campo"
              >
                <Trash2 className="h-4 w-4 text-destructive" />
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
